<template>
  <div :class="[{'visible':menuOn},'main-menu']">
    <!-- agregar visible active para mostrar el menu    <div class="main-menu visible">-->
    <button class="back-button1" @click="() => { menuVisible()}">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="7.997"
        height="12.995"
        viewBox="0 0 7.997 12.995"
      >
        <path
          id="Rectángulo_10"
          data-name="Rectángulo 10"
          d="M433,578l8,6.5-8,6.5Z"
          transform="translate(-433 -578.003)"
          fill="#00b99e"
        />
      </svg>
    </button>
    <div class="container main-container">
      <div class="menu-content">
        <div class="banner" :style="{'background': 'none','min-height':'1%'}">
          <nav>
            <div class="container">
              <div class="row navbar align-items-center">
                <div class="col-auto">
                  <button class="button secondary back-button" @click="() => { menuVisible()}">
                    <svg width="10.975" height="9.998" viewBox="0 0 10.975 9.998">
                      <path
                        id="Color_Overlay"
                        data-name="Color Overlay"
                        d="M26.825,57.835l-3.549-4.046A.634.634,0,0,1,23,53.244v-.366a.7.7,0,0,1,.068-.308.641.641,0,0,1,.14-.282l3.615-4.122a.439.439,0,0,1,.706.028l.205.267a.706.706,0,0,1-.023.861L25.13,52.268h8.343a.564.564,0,0,1,.5.609v.366a.564.564,0,0,1-.5.609H25.236l2.478,2.825a.708.708,0,0,1,.023.861l-.205.266a.462.462,0,0,1-.365.194A.455.455,0,0,1,26.825,57.835Z"
                        transform="translate(-23 -48.001)"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </nav>
        </div>  
        <div class="container main-menu-container">
          <div class="item-container noPadding">
            <div class="menu-section">
              <fi :fi="fi" @selectMedia="selectMedia"></fi>
              <keywords :keywords="keywords" :keywordSelected="keywordSelected" @setKeyword="setKeyword"></keywords>
            </div><!-- menu-section -->
          </div><!--item-container-->
        </div>
      </div>
    </div>
  </div>
</template>



<script>

import { library } from '@fortawesome/fontawesome-svg-core'
import { faNewspaper } from '@fortawesome/free-solid-svg-icons'

import fi from '@/components/toolMenu/fi'
import keywords from '@/components/toolMenu/keywords'


library.add(faNewspaper)
export default {
  name: "toolMenu",
  props: ["menuOn","fi","keywords","keywordSelected","andQuery"],
  components:{fi,keywords},
  data() {
    return {
      isLoading: false,
      currentRoute : this.$router.currentRoute.name, //naye
      //view : this.$store.state.mode,
      view :  3,
      options:[{label:'Modo Gráfico',value:1},{label:'Modo Texto',value:2},{label:'Escaleta',value:3}]
    };
  },
  created(){
    console.log(this.view)
    window.scrollTo(0, 0); 
  },
  methods: {
    getBanner() {
      if (this.$store.state.userInfo.banner) {
        return this.$store.state.userInfo.banner;
      } else {
        return this.$store.state.defaultBanner;
      }
    },
    selectMedia(ndx) {
      this.$emit('selectMedia',ndx);
    },
    setKeyword(index){
      this.$emit('setKeyword',index);
    },
    menuVisible() {
      this.$emit("menuVisible", false);
    }
  }
};
</script>

<style lang="scss">

 

.menu-item a {
  cursor: pointer;
}
.menu-link {
  cursor: pointer;
}
.main-menu {
  transition: all 1s !important;
  -webkit-transition: all 1s !important;
}

.fil1 {
  fill: #fefefe;
  fill-rule: nonzero;
}
.fil0 {
  fill: #00b99e;
  fill-rule: nonzero;
}

.uAvatar {
  height: 50px;
  width: 50px;
  border-radius: 50%;
}
</style>
